const CP437_HIGH_CHARACTERS =
  "ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜ¢£¥₧ƒ" +
  "áíóúñÑªº¿⌐¬½¼¡«»" +
  "░▒▓│┤╡╢╖╕╣║╗╝╜╛┐" +
  "└┴┬├─┼╞╟╚╔╩╦╠═╬╧" +
  "╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀" +
  "αßΓπΣσµτΦΘΩδ∞φε∩" +
  "≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ";

export function encodeCp437(text: string): Uint8Array {
  const bytes: number[] = [];
  for (const character of text) {
    const codePoint = character.codePointAt(0)!;
    if (codePoint <= 0x7f) {
      bytes.push(codePoint);
      continue;
    }
    const index = CP437_HIGH_CHARACTERS.indexOf(character);
    if (index === -1) {
      throw new RangeError(`The character ${JSON.stringify(character)} is not supported by the RT4K SD card.`);
    }
    bytes.push(0x80 + index);
  }
  return Uint8Array.from(bytes);
}

export function decodeCp437(bytes: Uint8Array): string {
  return [...bytes]
    .map((byte) => byte < 0x80 ? String.fromCharCode(byte) : CP437_HIGH_CHARACTERS[byte - 0x80])
    .join("");
}
